import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { DiffIcon } from './DiffIcon';
export const formatNumber = (value) => value ? Math.round(100 * value) / 100 : 0;
export const Diff = ({ diff }) => {
    if (typeof diff === 'undefined' || Math.abs(diff) <= 0.01) {
        return null;
    }
    return _jsxs(_Fragment, { children: [_jsx(DiffIcon, { positive: diff > 0 }), diff > 0 ? formatNumber(diff) : Math.abs(formatNumber(diff)), "%"] });
};
